module.exports = __webpack_public_path__ + "header-profile-skin-1.85efa900c0fc12fee15a.png";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src154282656/src/www-arthcloud/src/assets/styles/patterns/header-profile-skin-1.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-1.png
// module chunks = 2